export default "__VITE_ASSET__ce870585__"